import { Checkbox, FormControlLabel, Box, Typography, Alert, AlertTitle, Paper } from '@mui/material';
import { ShieldCheck, AlertCircle } from 'lucide-react';

export default function Step13Conferma({ data, onChange, errors, missingCount }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Conferma e invio
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Controlla con attenzione prima di inviare
        </Typography>
      </Box>

      {missingCount > 0 && (
        <Alert severity="warning" icon={<AlertCircle size={20} />} sx={{ borderRadius: 3 }}>
          <AlertTitle sx={{ fontWeight: 600 }}>Attenzione</AlertTitle>
          Ci sono ancora {missingCount} {missingCount === 1 ? 'campo obbligatorio' : 'campi obbligatori'} da compilare. Puoi salvare come bozza e completare in seguito.
        </Alert>
      )}

      <Paper variant="outlined" sx={{ p: 3, borderRadius: 3, bgcolor: 'background.paper' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Box sx={{ 
            width: 40, 
            height: 40, 
            borderRadius: '50%', 
            bgcolor: 'primary.light', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center' 
          }}>
            <ShieldCheck color="white" />
          </Box>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Privacy e consensi</Typography>
            <Typography variant="caption" color="text.secondary">Obbligatori per procedere</Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.consenso_privacy || false}
                onChange={e => onChange('consenso_privacy', e.target.checked)}
                size="small"
              />
            }
            label={
              <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                Dichiaro di aver preso visione dell'informativa sulla privacy e di acconsentire al trattamento dei miei dati personali
                {errors?.consenso_privacy && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
              </Typography>
            }
            sx={{ alignItems: 'flex-start', m: 0, gap: 1 }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={data.consenso_veridicita || false}
                onChange={e => onChange('consenso_veridicita', e.target.checked)}
                size="small"
              />
            }
            label={
              <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                Confermo che tutti i dati forniti sono veritieri e corrispondono alla mia situazione attuale
                {errors?.consenso_veridicita && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
              </Typography>
            }
            sx={{ alignItems: 'flex-start', m: 0, gap: 1 }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={data.consenso_trattamento || false}
                onChange={e => onChange('consenso_trattamento', e.target.checked)}
                size="small"
              />
            }
            label={
              <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                Autorizzo il trattamento dei dati per le finalità connesse alla presente richiesta di finanziamento
                {errors?.consenso_trattamento && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
              </Typography>
            }
            sx={{ alignItems: 'flex-start', m: 0, gap: 1 }}
          />
        </Box>
      </Paper>
    </Box>
  );
}